/* URLs that CloudWatch RUM must not record. RUM events land in a log group that every signed-in user
 * can query, so the multi-cost-center export API calls and the presigned download URLs stay out of
 * both the HTTP and the performance telemetry.
 */

/**
 * aws-rum-web's own HTTP exclusions (Cognito Identity and STS). Setting `urlsToExclude` replaces the
 * library default, so they are repeated here.
 */
const RUM_DEFAULT_HTTP_URLS_TO_EXCLUDE: readonly RegExp[] = [/cognito-identity\.([^.]*\.)?amazonaws\.com/, /sts\.([^.]*\.)?amazonaws\.com/];

/** The export API: its custom domain (`export-api.…`) and its `/actuals-exports` routes on any host. */
const ACTUALS_EXPORT_API_URL_PATTERNS: readonly RegExp[] = [/^https?:\/\/export-api\./, /\/actuals-exports(\/|\?|$)/];

/** Presigned download URLs of the exports bucket. */
const ACTUALS_EXPORT_DOWNLOAD_URL_PATTERN = /\.s3\.us-west-2\.amazonaws\.com\/exports\//;

const ACTUALS_EXPORT_URL_PATTERNS: readonly RegExp[] = [...ACTUALS_EXPORT_API_URL_PATTERNS, ACTUALS_EXPORT_DOWNLOAD_URL_PATTERN];

/** `http` telemetry `urlsToExclude`: the library defaults plus the export URLs. */
export const RUM_HTTP_URLS_TO_EXCLUDE: RegExp[] = [...RUM_DEFAULT_HTTP_URLS_TO_EXCLUDE, ...ACTUALS_EXPORT_URL_PATTERNS];

export const isActualsExportTelemetryUrl = (url: string): boolean => ACTUALS_EXPORT_URL_PATTERNS.some((pattern) => pattern.test(url));

/**
 * `performance` telemetry `ignore`: aws-rum-web's default rule (resources that are not http(s), or
 * that were fetched by fetch/XHR) plus every entry for an export URL.
 */
export const ignoreRumPerformanceEntry = (entry: PerformanceEntry): boolean => {
  const initiatorType = (entry as Partial<PerformanceResourceTiming>).initiatorType ?? '';
  const isDefaultIgnored = entry.entryType === 'resource' && (!/^https?:/.test(entry.name) || /^(fetch|xmlhttprequest)$/.test(initiatorType));
  return isDefaultIgnored || isActualsExportTelemetryUrl(entry.name);
};
